module.exports = __webpack_public_path__ + "ccde84e9ecc7b064a2441d57183861a4.jpg";